import { createContentReport, type ReportReason, type ReportTargetType } from './api';

export async function reportContent(opts: {
  targetType: ReportTargetType;
  targetId: string;
  parentId?: string;
  sellerUserId?: string;
  reportedUserId?: string;
  reason?: ReportReason;
  note?: string;
}) {
  return createContentReport({
    targetType: opts.targetType,
    targetId: opts.targetId,
    parentId: opts.parentId,
    sellerUserId: opts.sellerUserId,
    reportedUserId: opts.reportedUserId,
    reason: opts.reason ?? 'other',
    note: opts.note,
  });
}
